$(function(){
    var $sidebar = $('.sidebar');
    var $trigger = $('.sidebar-trigger');
    var desktop  = window.matchMedia("(min-width: 1441px)");
    var smallDesktop = window.matchMedia("(min-width:1301px) and (max-width: 1440px)");
    var verySmallDesktop = window.matchMedia("(min-width:1101px) and (max-width: 1300px)");
    var tablet  = window.matchMedia("(max-width: 1100px)");
    var mobile  = window.matchMedia("(max-width: 768px)");

    $trigger.on('click', function(e){
        e.preventDefault();

        $(this).find('.fa-chevron-left').toggleClass('hidden');
        $(this).find('.fa-chevron-right').toggleClass('hidden');
        $(this).toggleClass('active');
        $sidebar.toggleClass('active');

        ($(this).attr('data-state') != 'active') ? openNav() : closeNav();



    });

    // match media
    var mq = window.matchMedia("(min-width: 1771px)");

    if (mq.matches) {
        $trigger.find('.fa-chevron-left').removeClass('hidden');
        $trigger.find('.fa-chevron-right').addClass('hidden');
        openNav();
    }

    if(!mq.matches) {
        $sidebar.removeClass('active');
        $trigger.removeClass('active');
        closeNav();
    }

    /* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
    function openNav() {
        $trigger.attr('data-state', 'active');
        if (desktop.matches) {
            document.getElementById("main").style.marginLeft = "400px";
            document.querySelector(".title-container").style.marginLeft = "400px";
            document.querySelector(".title").style.marginLeft = "0";
        }

        if (smallDesktop.matches) {
            document.querySelector(".title").style.marginLeft = "150px";
            document.getElementById("main").style.marginLeft = "450px";
            document.querySelector(".title-container").style.marginLeft = "450px";
        }

        if (verySmallDesktop.matches) {
            document.querySelector(".title").style.marginLeft = "150px";
            document.getElementById("main").style.marginLeft = "450px";
            document.querySelector(".title-container").style.marginLeft = "450px";
        }
    }
    
    /* Set the width of the side navigation to 0 and the left margin of the page content to 0, and the background color of body to white */
    function closeNav() {
        $trigger.attr('data-state', 'inactive');
        let width = parseInt($trigger.css('width'));

        if (width > 200) {
            width = 200
        }

        if (tablet.matches) {
            document.querySelector(".title").style.marginLeft = width;
        }
        else if (desktop.matches) {
            document.getElementById("main").style.marginLeft = "0";
            document.querySelector(".title").style.marginLeft = "0";
            document.querySelector(".title-container").style.marginLeft = "0";
        }
        else if (verySmallDesktop.matches) {
            document.querySelector(".title").style.marginLeft = width;
            document.querySelector(".title-container").style.marginLeft = "0px";
            document.getElementById("main").style.marginLeft = "0px";

        }
        else if (smallDesktop.matches) {
            document.querySelector(".title").style.marginLeft = '0px';
            document.querySelector(".title-container").style.marginLeft = "0px";
            document.getElementById("main").style.marginLeft = "0px";

        }


    }
});
